// import { useEffect } from "react";

// function useActiveScrollSection(
//   sectionMap,
//   activeSubKey,
//   setActiveSubKey,
//   programmaticScrollRef
// ) {
//   useEffect(() => {
//     let scrollTimeout = null;
//     let ticking = false;

//     const handleScroll = () => {
//       if (programmaticScrollRef?.current) return;
//       if (ticking) return;

//       ticking = true;

//       window.requestAnimationFrame(() => {
//         if (scrollTimeout) clearTimeout(scrollTimeout);

//         scrollTimeout = setTimeout(() => {
//           const scrollPosition = window.scrollY + 120;
//           let currentKey = null;

//           const sections = Object.entries(sectionMap).filter(
//             ([, ref]) => ref?.current
//           );

//           sections.forEach(([key, ref]) => {
//             const top = ref.current.offsetTop;
//             const height = ref.current.offsetHeight;

//             if (scrollPosition >= top && scrollPosition < top + height) {
//               currentKey = key;
//             }
//           });

//           const isAtBottom =
//             window.innerHeight + window.scrollY >=
//             document.documentElement.scrollHeight - 5;

//           if (isAtBottom && sections.length > 0) {
//             currentKey = sections[sections.length - 1][0];
//           }

//           if (currentKey && currentKey !== activeSubKey) {
//             setActiveSubKey(currentKey);
//           }
//         }, 200);

//         ticking = false;
//       });
//     };

//     window.addEventListener("scroll", handleScroll, { passive: true });

//     handleScroll();

//     return () => {
//       window.removeEventListener("scroll", handleScroll);

//       if (scrollTimeout) clearTimeout(scrollTimeout);
//     };
//   }, [sectionMap, activeSubKey, setActiveSubKey, programmaticScrollRef]);
// }

// export default useActiveScrollSection;

// import { useEffect, useState } from "react";

// function useActiveScrollSection(
//   sectionMap,
//   activeSubKey,
//   setActiveSubKey,
//   programmaticScrollRef
// ) {
//   const [showScrollTop, setShowScrollTop] = useState(false);

//   useEffect(() => {
//     let scrollTimeout = null;
//     let ticking = false;

//     const handleScroll = () => {
//       if (programmaticScrollRef?.current) return;

//       setShowScrollTop(window.scrollY > 400);

//       if (ticking) return;
//       ticking = true;

//       window.requestAnimationFrame(() => {
//         if (scrollTimeout) clearTimeout(scrollTimeout);

//         scrollTimeout = setTimeout(() => {
//           const scrollPosition = window.scrollY + 120;
//           let currentKey = null;

//           const sections = Object.entries(sectionMap).filter(
//             ([, ref]) => ref?.current
//           );

//           sections.forEach(([key, ref]) => {
//             const top = ref.current.offsetTop;
//             const height = ref.current.offsetHeight;

//             if (scrollPosition >= top && scrollPosition < top + height) {
//               currentKey = key;
//             }
//           });

//           const isAtBottom =
//             window.innerHeight + window.scrollY >=
//             document.documentElement.scrollHeight - 5;

//           if (isAtBottom && sections.length > 0) {
//             currentKey = sections[sections.length - 1][0];
//           }

//           if (currentKey && currentKey !== activeSubKey) {
//             setActiveSubKey(currentKey);
//           }
//         }, 90);

//         ticking = false;
//       });
//     };

//     window.addEventListener("scroll", handleScroll, { passive: true });

//     handleScroll();

//     return () => {
//       window.removeEventListener("scroll", handleScroll);

//       if (scrollTimeout) clearTimeout(scrollTimeout);
//     };
//   }, [sectionMap, activeSubKey, setActiveSubKey, programmaticScrollRef]);

//   const scrollToTop = () => {
//     window.scrollTo({
//       top: 0,
//       behavior: "smooth",
//     });
//     const firstKey = Object.keys(sectionMap)[0];

//     if (firstKey) {
//       setActiveSubKey(firstKey);
//     }
//   };

//   return {
//     showScrollTop,
//     scrollToTop,
//   };
// }

// export default useActiveScrollSection;

// import { useEffect, useState } from "react";

// function useActiveScrollSection(
//   sectionMap,
//   activeSubKey,
//   setActiveSubKey,
//   programmaticScrollRef,
//   refreshTrigger // NEW
// ) {
//   const [showScrollTop, setShowScrollTop] = useState(false);

//   useEffect(() => {
//     let scrollTimeout = null;
//     let ticking = false;

//     const handleScroll = () => {
//       if (programmaticScrollRef?.current) return;

//       setShowScrollTop(window.scrollY > 400);

//       if (ticking) return;
//       ticking = true;

//       window.requestAnimationFrame(() => {
//         if (scrollTimeout) clearTimeout(scrollTimeout);

//         scrollTimeout = setTimeout(() => {
//           // const scrollPosition = window.scrollY + 120;
//           const scrollPosition = window.scrollY + 200;
//           let currentKey = null;

//           const sections = Object.entries(sectionMap).filter(
//             ([, ref]) => ref?.current
//           );

//           sections.forEach(([key, ref]) => {
//             // const top = ref.current.offsetTop;
//             // const height = ref.current.offsetHeight;

//             // if (scrollPosition >= top && scrollPosition < top + height) {
//             //   currentKey = key;
//             // }

//             const rect = ref.current.getBoundingClientRect();
//             const top = rect.top + window.scrollY;
//             const bottom = top + rect.height;

//             if (scrollPosition >= top && scrollPosition < bottom) {
//               currentKey = key;
//             }
//           });

//           const isAtBottom =
//             window.innerHeight + window.scrollY >=
//             document.documentElement.scrollHeight - 5;

//           if (isAtBottom && sections.length > 0) {
//             currentKey = sections[sections.length - 1][0];
//           }

//           if (currentKey && currentKey !== activeSubKey) {
//             setActiveSubKey(currentKey);
//           }
//         }, 90);

//         ticking = false;
//       });
//     };

//     window.addEventListener("scroll", handleScroll, { passive: true });
//     setTimeout(handleScroll, 0);

//     handleScroll();

//     return () => {
//       window.removeEventListener("scroll", handleScroll);

//       if (scrollTimeout) clearTimeout(scrollTimeout);
//     };
//   }, [
//     sectionMap,
//     activeSubKey,
//     setActiveSubKey,
//     programmaticScrollRef,
//     refreshTrigger,
//   ]);

//   const scrollToTop = () => {
//     window.scrollTo({
//       top: 0,
//       behavior: "smooth",
//     });
//     const firstKey = Object.keys(sectionMap)[0];

//     if (firstKey) {
//       setActiveSubKey(firstKey);
//     }
//   };

//   return {
//     showScrollTop,
//     scrollToTop,
//   };
// }

// export default useActiveScrollSection;

import { useEffect, useState } from "react";

function useActiveScrollSection(
  sectionMap,
  activeSubKey,
  setActiveSubKey,
  programmaticScrollRef,
  refreshTrigger, // pass API/table data or any change trigger
  containerRef
) {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    let scrollTimeout = null;
    let ticking = false;

    const handleScroll = () => {
      if (programmaticScrollRef?.current) return;

      // setShowScrollTop(window.scrollY > 400);
      const scrollTop = containerRef?.current
        ? containerRef.current.scrollTop
        : window.scrollY;

      setShowScrollTop(scrollTop > 400);

      if (ticking) return;
      ticking = true;

      window.requestAnimationFrame(() => {
        if (scrollTimeout) clearTimeout(scrollTimeout);

        scrollTimeout = setTimeout(() => {
          let currentKey = null;

          const sections = Object.entries(sectionMap).filter(
            ([, ref]) => ref?.current
          );

          // 🔹 viewport-based detection
          let minDistance = Infinity;

          sections.forEach(([key, ref]) => {
            const rect = ref.current.getBoundingClientRect();

            // adjust 120 based on sticky header height
            const distance = Math.abs(rect.top - 120);

            const isVisible =
              rect.top <= window.innerHeight && rect.bottom >= 0;

            if (isVisible && distance < minDistance) {
              minDistance = distance;
              currentKey = key;
            }
          });

          // 🔹 bottom fallback
          const isAtBottom =
            window.innerHeight + window.scrollY >=
            document.documentElement.scrollHeight - 5;

          if (isAtBottom && sections.length > 0) {
            currentKey = sections[sections.length - 1][0];
          }

          if (currentKey && currentKey !== activeSubKey) {
            setActiveSubKey(currentKey);
          }
        }, 90);

        ticking = false;
      });
    };

    // window.addEventListener("scroll", handleScroll, { passive: true });
    const scrollEl = containerRef?.current || window;

    scrollEl.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll);

    // 🔹 initial + post-render recalculation
    handleScroll();
    setTimeout(handleScroll, 50);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);

      if (scrollTimeout) clearTimeout(scrollTimeout);
    };
  }, [
    sectionMap,
    activeSubKey,
    setActiveSubKey,
    programmaticScrollRef,
    refreshTrigger, // IMPORTANT for dynamic tables
  ]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "instant",
    });

    const firstKey = Object.keys(sectionMap)[0];
    if (firstKey) {
      setActiveSubKey(firstKey);
    }
  };

  return {
    showScrollTop,
    scrollToTop,
  };
}

export default useActiveScrollSection;
